import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { SliderModule } from 'primeng/slider';

@Component({
  selector: 'lib-scoring-input-range',
  imports: [CommonModule, ReactiveFormsModule, SliderModule, InputNumberModule],
  templateUrl: './input-range.component.html',
  styleUrl: './input-range.component.scss',
})
export class InputRangeComponent {
  @Input({ required: true }) label: string;
  @Input({ required: true }) model: Record<string, any>;
  @Input({ required: true }) modelKey: string;
  @Input({ required: true }) control: FormControl;
}
